﻿export default class RSE{
    constructor() {
        this.$wrapper = document.querySelector('.js-rse-wheel');
        if( this.$wrapper ) {
            this.init();
            this.bindEvents();
        }
    }

    bindEvents(){
        let $wrapper = this.$wrapper;
        let $this = this;
        const header = document.querySelector('.js-rse-wheel-head');
        const bullets = document.querySelector('.js-rse-wheel-bullets');
        const schema = document.querySelector('.js-rse-wheel-schema');
        schema.classList.add('is-not-animated');

        if (!header) return;

        const desktopQuery = '(min-width: 1025px)';
        const $slider = jQuery('.js-rse-mobile-slider');
        const $schema = jQuery('.js-rse-wheel-schema');

        const isDesktop = () => window.matchMedia(desktopQuery).matches;

        const getPillarsOffsets = () => {
            let pillars = [];
            document.querySelectorAll('.js-pillar').forEach(function (item) {
                pillars.push(item.getBoundingClientRect().top + window.scrollY - window.innerHeight);
            });
            return pillars;
        };

        const resetStickyState = () => {
            [header, schema, bullets].forEach((el) => {
                if (!el) return;
                el.classList.remove('is-sticky', 'is-stopped');
                el.style.top = '';
                el.style.left = '';
            });
        };

        const onDesktopScroll = () => {
            if (!isDesktop()) {
                resetStickyState();
                return;
            }

            const schemaLeft = schema.getBoundingClientRect().left + window.scrollX;
            const bulletLeft = bullets.getBoundingClientRect().left + window.scrollX;
            const wrapperTop = $wrapper.offsetTop;
            const wrapperHeight = $wrapper.offsetHeight;
            const wrapperBottom = wrapperTop - window.innerHeight + wrapperHeight;
            const pillars = getPillarsOffsets();
            const scrollY = window.scrollY;

            header.classList.remove('is-sticky', 'is-stopped');
            schema.classList.remove('is-sticky', 'is-stopped');
            bullets.classList.remove('is-sticky', 'is-stopped');

            if (scrollY > wrapperTop - (window.innerHeight / 2) && (scrollY + header.offsetHeight) < wrapperBottom + 70) {
                schema.classList.add('is-animated');
                schema.classList.remove('is-not-animated');
            }

            if (scrollY > wrapperTop && (scrollY + header.offsetHeight) < wrapperBottom + 70) {
                header.classList.add('is-sticky');
                schema.classList.add('is-sticky');
                bullets.classList.add('is-sticky');

                bullets.style.top = 0;
                schema.style.top = 0;
                schema.style.left = schemaLeft + 'px';
                bullets.style.left = bulletLeft + 'px';
            } else if ((scrollY + header.offsetHeight) >= (wrapperBottom + 70)) {
                header.classList.add('is-stopped');
                schema.classList.add('is-stopped');
                bullets.classList.add('is-stopped');

                schema.style.left = '8rem';
                bullets.style.left = 'auto';

                schema.style.top = (wrapperHeight - window.innerHeight - 90) + 'px';
                bullets.style.top = (wrapperHeight - window.innerHeight - 90) + 'px';
            } else {
                schema.style.left = '0';
                bullets.style.left = 'auto';
            }

            let currentPillar = 'climat';
            document.querySelectorAll('.js-pillar').forEach(function (item, i) {
                if (scrollY > pillars[i]) {
                    currentPillar = item.dataset.pillar;
                }
            });

            $this.setPillar(currentPillar);
        };

        const initMobileSlider = () => {
            if ($slider.hasClass('slick-initialized')) {
                $slider.slick('unslick');
            }

            $slider.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                adaptiveHeight: true,
                fade: true,
                infinite: true,
                arrows: false
            });

            $slider.off('beforeChange.rse').on('beforeChange.rse', function(event, slick, currentSlide, nextSlide){
                $this.setPillar($slider.find('.js-pillar-item').eq(nextSlide).attr('id'));
            });

            let startX = 0;
            let endX = 0;

            $schema.off('touchstart.rse').on('touchstart.rse', function(e) {
                startX = e.originalEvent.touches[0].clientX;
            });

            $schema.off('touchend.rse').on('touchend.rse', function(e) {
                endX = e.originalEvent.changedTouches[0].clientX;

                if (startX - endX > 30) {
                    $slider.slick('slickNext');
                } else if (endX - startX > 30) {
                    $slider.slick('slickPrev');
                }
            });

            jQuery('.js-bullet').off('click.rse').on('click.rse', function() {
                $this.setPillar(jQuery('.js-rse-filter').eq(jQuery(this).index()).attr('href').replace('#', ''));
                $slider.slick('slickGoTo', jQuery(this).index());
            });
        };

        const destroyMobileSlider = () => {
            $schema.off('.rse');
            jQuery('.js-bullet').off('click.rse');
            $slider.off('beforeChange.rse');

            if ($slider.hasClass('slick-initialized')) {
                $slider.slick('unslick');
            }
        };

        const applyMode = () => {
            if (isDesktop()) {
                destroyMobileSlider();
                resetStickyState();
                onDesktopScroll();
            } else {
                resetStickyState();
                requestAnimationFrame(initMobileSlider);
            }
        };

        window.addEventListener('scroll', onDesktopScroll);
        window.addEventListener('resize', applyMode);
        applyMode();

        document.querySelectorAll('.js-rse-filter').forEach((button, i) => {
            button.addEventListener('click', function(e) {
                e.preventDefault();

                if (isDesktop()) {
                    let $id = button.getAttribute('href');
                    window.scrollTo({
                        top: document.querySelector($id).getBoundingClientRect().top + window.scrollY - (window.innerHeight / 5),
                        left: 0,
                        behavior: 'smooth'
                    });
                    return;
                }

                $this.setPillar(button.getAttribute('href').replace('#', ''));
                if ($slider.hasClass('slick-initialized')) {
                    $slider.slick('slickGoTo', i);
                }
            });
        });

        document.querySelectorAll('.js-rse-open-popin').forEach(button => {
            button.addEventListener('click', function() {
                const targetId = this.getAttribute('data-target');
                document.querySelector('.rse-popin').classList.add('active');
                document.querySelector('body').classList.add('popin-open');
                document.querySelectorAll('.rse-popin__content-item').forEach(function (item) {
                    item.style.display = 'none';
                });
                document.getElementById('popin-' + targetId).style.display = 'block';
            });
        });

        document.querySelectorAll('.rse-popin__close, .rse-popin__overlay').forEach(el => {
            el.addEventListener('click', function() {
                this.closest('.rse-popin').classList.remove('active');
                document.querySelector('body').classList.remove('popin-open');
            });
        });
    }

    init(){
        const header = document.querySelector('.js-rse-wheel-head');

        if (!header) return;

        header.style.width = header.offsetWidth + 'px';
    }

    setPillar(currentPillar) {
        document.querySelectorAll('.js-schema').forEach(function (item) {
            item.style.opacity = 0.3;
        });

        document.querySelectorAll('.js-text, .js-bullet, .js-rse-filter').forEach(function (item) {
            item.classList.remove('is-active');
        });

        document.querySelector('a[href="#' + currentPillar + '"]').classList.add('is-active');
        document.querySelector('.js-schema-' + currentPillar).style.opacity = 1;
        document.querySelector('.js-text-' + currentPillar).classList.add('is-active');
        document.querySelector('.js-bullet-' + currentPillar).classList.add('is-active');
    }
}
